import baseApi from '../utils/ApiUtils';

export const notificationsApi = (method, id, payload = null, params = null) => {
  return baseApi(`/users/${id}/notifications/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const notificationRead = (method, id, payload = null, params = null) => {
  return baseApi(`/notifications/${id}`, method, params, payload).then(
    (response) => {
      return response.data;
    }
  );
};